export default {
  'pl': {
    'PAID': 'Opłacona',
    'UNPAID': 'Nieopłacona'
  },
  'en': {
    'PAID': 'Paid',
    'UNPAID': 'Unpaid'
  }
};
